/* eslint-disable camelcase */
import { getBackVersion } from '../config';
import {
    getBoletoRequestArgs,
    getCardRequestArgs,
    PaymentArgs,
    PaymentMethod,
} from '../lib/payments';
import { PointOrderSnapshot } from '../models';
import api from './api';

const getOrders = (): Promise<PointOrderSnapshot[]> => {
    return api.request<PointOrderSnapshot[]>({
        method: 'GET',
        url: `${getBackVersion()}/agent/point_orders`,
    });
};

const getOrder = (
    orderId: PointOrderSnapshot['id']
): Promise<PointOrderSnapshot> => {
    return api.request<PointOrderSnapshot>({
        method: 'GET',
        url: `${getBackVersion()}/agent/point_orders/` + orderId,
    });
};

type BaseCreateOrderArgs = {
    quantity: number;
    customerId?: number;
    deduplicationId: string;
} & PaymentArgs;

export type CreatePointOrderArgs = BaseCreateOrderArgs;

const createPointOrder = (
    args: CreatePointOrderArgs
): Promise<PointOrderSnapshot> => {
    const urlPrefixByMethod: Record<PaymentMethod, string> = {
        boleto: '/boleto',
        credit_card: '',
        pix: '/pix',
    };

    return api.request<PointOrderSnapshot>({
        method: 'POST',
        url: `${getBackVersion()}/agent/point_orders${
            urlPrefixByMethod[args.paymentMethod]
        }`,
        action: 'POINT_ORDER_REQUEST',
        data: {
            ...getCardRequestArgs(args),
            ...getBoletoRequestArgs(args),
            type: 'point',
            quantity: args.quantity,
            deduplication_id: args.deduplicationId,
            customer_id: args.customerId,
        },
    });
};

const getRecentlyPaidOrder = (
    quantity?: number
): Promise<PointOrderSnapshot> => {
    return api.request<PointOrderSnapshot>({
        method: 'GET',
        params: { quantity },
        url: `${getBackVersion()}/agent/point_orders/recently_paid`,
    });
};

export default { createPointOrder, getOrders, getOrder, getRecentlyPaidOrder };
